import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { LoginData } from "../../../Utils/Types";


let url = " "

export const login = createAsyncThunk(
    'user/login',
    async (data: LoginData) => {
          const response = await axios.post(url, { data })
          return response.data;
    }
) 

